var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-component"},[_c('h1',[_vm._v(_vm._s(_vm.$t('W2P_MY_ORDERS')))]),_c('TableComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }